export default (state) => state.navigation.toggled
